import React from 'react';
import { Link } from 'react-router-dom';
import { Urls } from 'data';
import { Button } from 'components/ui/button';
import pilgrims from 'assets/img/hero/hero-pilgrims.jpg';

const About = () => (
  <section id="presentation" className="py-11 min-[681px]:py-[66px]" aria-labelledby="presentation-title">
    <div className="mx-auto w-[calc(100%-40px)] min-[681px]:w-[calc(100%-56px)] min-[1001px]:w-[calc(100%-112px)] grid max-w-[1248px] items-center gap-7 min-[681px]:grid-cols-2 min-[1001px]:gap-[58px]">
      <div className="h-[255px] w-full overflow-hidden rounded-[10px] min-[681px]:h-[370px] min-[1001px]:h-[385px]">
        <img
          className="h-full w-full scale-[1.2] object-cover"
          src={pilgrims}
          alt="Un groupe de pèlerins devant une mosquée"
          width="2184"
          height="1800"
          loading="lazy"
        />
      </div>
      <div>
        <span className="mb-4 inline-block rounded bg-[#30372d] px-[13px] py-[5px] text-[13px] text-white">
          À propos
        </span>
        <h2
          id="presentation-title"
          className="mb-6 text-[25px] font-semibold leading-[1.3] text-inherit min-[681px]:text-[28px]"
        >
          La plateforme officielle qui accompagne votre pèlerinage pas à pas
        </h2>
        <p className="mb-3 text-base leading-[inherit] text-[#586357]">
          eHadj est la plateforme officielle de gestion du Hadj pour le Bénin.
        </p>
        <p className="mb-3 text-base leading-[inherit] text-[#586357]">
          Elle a été conçue pour simplifier, sécuriser et centraliser toutes les démarches liées au pèlerinage à La
          Mecque.
        </p>
        <p className="mb-3 text-base leading-[inherit] text-[#586357]">
          Grâce à une organisation rigoureuse et un accompagnement humain, eHadj permet à chaque pèlerin de se
          concentrer sur l’essentiel : son cheminement spirituel.
        </p>
        <Button
          asChild
          className="mt-3 h-auto min-h-[42px] whitespace-normal bg-[#cde8d2] px-6 py-2.5 text-[#18563b] hover:bg-[#bbddc3]"
        >
          <Link to={Urls.register}>S’inscrire en tant que pèlerin</Link>
        </Button>
      </div>
    </div>
  </section>
);
export default About;
